module.exports = __webpack_public_path__ + "img/Human_symbol_8.0fc531a7.png";